/* eslint-disable */

import {CoodeSdk, CoodeSdkOptions, Environments, LogLevel} from '@coode/fe-sdk'

export const MSP_SCOPE = `api://${process.env.VUE_APP_CLIENT_ID}/coode`;
export const PML_SCOPE = `api://${process.env.VUE_APP_PML_CLIENT_ID}/coode`;

const coodeSdkConfig: CoodeSdkOptions = {
    environment: process.env.VUE_APP_ENVIRONMENT as Environments,
    auth: {
        msal: {
            auth: {
                clientId: process.env.VUE_APP_CLIENT_ID as string,
                authority: process.env.VUE_APP_AUTHORITY_URL,
                redirectUri: window.location.origin,
                postLogoutRedirectUri: `${window.location.origin}/authorization/logged-out.html`,
            },
            cache: {
                cacheLocation: 'sessionStorage'
            },
            system: {
                loggerOptions: {
                    logLevel: LogLevel.Error,
                },
            },
        },
    },
    insights: {
        appInsightsConnectionString: process.env.VUE_AI_CONNECTION_STRING,
    },
    phraseProjectId: process.env.VUE_APP_PHRASE_PROJECT_ID,
    phraseProjectDefaultLanguage: 'en-GB',
};

export const coodeSdk = new CoodeSdk(coodeSdkConfig);
